@for (listGroup of data; track listGroup) {
  <div class="grouped-list">
    <div class="list-group-header">
      @if (listGroup.icon) {
        <i [class]="'icon-' + listGroup.icon"></i>
      }
      {{ listGroup.name }}
    </div>
    <div class="list-items">
      @for (listItem of listGroup.items; track listItem) {
        <div
          class="list-item"
          [class.disabled]="listItem.disabled"
          [class.no-image]="!listItem.image && !listItem.imagePlaceholder"
          (click)="selectItem(listItem)"
          >
          <div class="list-item-image" (click)="showImage($event, listItem)">
            <div
              class="background-image"
              [class.no-image]="!listItem.image && !listItem.imagePlaceholder"
              [remoteImage]="listItem.image"
              [imagePlaceholder]="listItem.imagePlaceholder"
              [remoteImageSize]="'thumb'"
              lhBackgroundImage
            ></div>
            <!-- First icon -->
            @if (listItem.icons && listItem.icons[0]) {
              <div
                class="list-item-icon"
                [class.no-image]="!listItem.image && !listItem.imagePlaceholder"
                >
                <i [class]="listItem.icons[0].class"></i> {{ listItem.icons[0].text }}
              </div>
            }
            <!-- Second icon (shown on hover) -->
            @if (listItem.icons && listItem.icons[0]) {
              <div
                class="list-item-icon alt"
                [class.no-image]="!listItem.image && !listItem.imagePlaceholder"
                >
                <!-- Use first icon when there is no image or second icon -->
                @if (!listItem.icons[1] || !listItem.image) {
                  <span>
                    <i [class]="listItem.icons[0].class"></i> {{ listItem.icons[0].text }}
                  </span>
                }
                <!-- Use second icon if provided and there is an image -->
                @if (listItem.icons[1] && listItem.image) {
                  <span>
                    <i [class]="listItem.icons[1].class"></i> {{ listItem.icons[1].text }}
                  </span>
                }
              </div>
            }
          </div>
          <div class="list-item-content">
            <div class="list-item-header">
              <!-- Title and labels -->
              <span class="list-item-title">{{ listItem.title }}</span>
              <span class="list-item-labels">
                @for (label of listItem.labels; track label) {
                  <span [class]="label.class" [tooltip]="label.tooltip">{{
                    label.text
                  }}</span>
                }
              </span>
            </div>
            <!-- Main text contents of the item -->
            <div class="list-item-body">
              @if (listItem.content.strong) {
                <span class="strong">{{ listItem.content.strong }}</span>
              }
              <span>{{ listItem.content.normal }}</span>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
}
